import { render } from "./ButtonLink.vue?vue&type=template&id=523b47c0&scoped=true"
import script from "./ButtonLink.vue?vue&type=script&lang=js"
export * from "./ButtonLink.vue?vue&type=script&lang=js"

import "./ButtonLink.vue?vue&type=style&index=0&id=523b47c0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523b47c0"]])

export default __exports__